import { useEffect, useState } from "react";
import AppLayout, { MainBody } from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { BodyDiv } from "../../components/components-style";
import {
  CaptionText,
  LittleSubHeadline,
  TextBody,
} from "../../components/typography";
import Input from "../../components/ui/inputs";
import getData from "../../api/project-request";
import { API_URL_COMPANY, API_URL_CONTACT } from "../../constants";
import {
  NameIdType,
  TypeClientEnum,
  typeClientObj,
} from "../../assets/utils/enums/project";
import { useFormValidation } from "../../assets/utils/hooks/useFormsValidation";
import { validateCompany } from "../../assets/utils/validation/form/validator-company";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import CustomToast from "../../components/ui/custom-toast";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ValidationFormsModeEnum } from "../../assets/utils/validation/form/types";
import { Button } from "../../components/ui/button";
import { COLORS } from "../../assets/utils/enums/colors";
import { GeneralItemBlock } from "../project/add";
import { authFetch } from "../../api/authFetch";

export default function AddCompanyPage() {
  const [name, setName] = useState<string>("");
  const [site, setSite] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [responsibleContact, setResponsibleContact] = useState<string>("");
  const [type, setType] = useState<string>(TypeClientEnum.POTENTIAL_CLIENT);

  const [types, setTypes] = useState<NameIdType[]>([]);

  const [filterResponsible, setFilterResponsible] = useState<
    { fullName: string; email: string }[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { errors, validate } = useFormValidation(validateCompany);
  const navigate = useNavigate();

  useEffect(() => {
    const getTypes = () => {
      setIsLoading(true);
      setTimeout(async () => {
        const data = await getData(
          `https://back.galera.fm/api/CustomerTypes/get-all`
        );
        setTypes(data);
        setIsLoading(false);
      }, 50);
    };
    getTypes();
  }, []);

  useEffect(() => {
    const getResponsibleUsers = async () => {
      const data = await getData(
        `${API_URL_CONTACT}/search-by-company?query=${responsibleContact}&companyId=`
      );
      setFilterResponsible(data.slice(0, 4));
    };

    getResponsibleUsers();
  }, [responsibleContact]);

  const handleSave = async () => {
    try {
      setIsLoading(true);

      const { hasErrors } = validate(
        {
          name,
          site,
          description,
          responsibleContact,
          type,
        },
        ValidationFormsModeEnum.ADD
      );

      if (hasErrors) return;

      const response = await authFetch(`${API_URL_COMPANY}/create-company`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name,
          description: description,
          siteLink: site,
          customerType: type,
          contactMainEmail: responsibleContact,
        }),
        credentials: "include",
      });

      if (!response.ok) {
        toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.WARNING}
            text={"Перевірте коректність введення даних!"}
          />
        ));
        return;
      }

      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.SUCCESS}
          text={"Дані введені коректно, компанія додана!"}
        />
      ));
      setTimeout(() => {
        navigate("/companies/main");
      }, 300);
    } catch (error) {
      console.error("Fetch error:", error);
      toast((t) => (
        <CustomToast
          t={t}
          text={"Упс, щось пішло не так\nПроблема з сервером."}
          type={ToastTypeEnum.ERROR}
        />
      ));
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 150);
    }
  };

  return (
    <AppLayout
      className="d-flex flex-column align-items-center"
      blockType={"item-form"}
      loaderState={isLoading}
    >
      <Headline
        headline={HeadlineTypeEnum.COMPANIES}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Повернутися до Компаній"
        btn_link="/companies/main"
      />
      <MainBody className="align-items-stretch">
        <BodyDiv
          data-class="add-block"
          className="d-flex flex-column align-items-center"
        >
          <CaptionText>Основні дані про компанію</CaptionText>
          <div className="w-100">
            <Input
              attribute="nameOfCompany"
              value={name}
              setValue={setName}
              errorText={errors.name}
              label="Назва"
              placeholder="Введіть назву компанії"
            />
            <Input
              attribute="website"
              value={site}
              setValue={setSite}
              errorText={errors.site}
              label="Сайт компанії"
              placeholder="https://testcompany.com"
            />
            <Input
              attribute="description"
              value={description}
              setValue={setDescription}
              errorText={""}
              label="Опис"
              placeholder="Напишіть трішки інформації про компанію"
            />
          </div>
        </BodyDiv>
        <BodyDiv data-class="add-block-other">
          <span className="w-100 d-flex flex-column align-items-center">
            <CaptionText>Представник компанії</CaptionText>
            <Input
              attribute="contact"
              value={responsibleContact}
              setValue={setResponsibleContact}
              errorText={""}
              label=""
              contactsArr={filterResponsible}
              placeholder="Введіть пошту / ім’я"
            />
          </span>
          <span className="w-100 d-flex flex-column align-items-center">
            <CaptionText>Тип</CaptionText>
            <GeneralItemBlock>
              {types!.map((item: NameIdType) => {
                const isActive: boolean = type === item.name;
                return (
                  <Button
                    key={item.id}
                    bgcolor={
                      isActive
                        ? typeClientObj[item.name as TypeClientEnum].bgColor
                        : "transparent"
                    }
                    txtcolor={
                      isActive
                        ? typeClientObj[item.name as TypeClientEnum].txColor
                        : COLORS["bg-text-color"]
                    }
                    brcolor={
                      isActive
                        ? typeClientObj[item.name as TypeClientEnum].bgColor
                        : COLORS["bg-text-color"]
                    }
                    width="100%"
                    type="large"
                    brradius="24px"
                    className=""
                    onClick={() => {
                      setType(item.name);
                    }}
                  >
                    <TextBody>{item.name as TypeClientEnum}</TextBody>
                    {isActive && (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 32 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M28.708 8.70799L14.708 22.708C14.6151 22.8011 14.5048 22.875 14.3833 22.9254C14.2618 22.9758 14.1315 23.0018 14 23.0018C13.8685 23.0018 13.7382 22.9758 13.6167 22.9254C13.4952 22.875 13.3849 22.8011 13.292 22.708L5.29199 14.708L6.70799 13.292L14 20.586L27.294 7.29199L28.708 8.70799Z"
                          fill={
                            isActive
                              ? typeClientObj[item.name as TypeClientEnum]
                                  .txColor
                              : "transparent"
                          }
                        />
                      </svg>
                    )}
                  </Button>
                );
              })}
            </GeneralItemBlock>
          </span>
        </BodyDiv>
      </MainBody>
      <Button
        bgcolor={COLORS.secondary1}
        txtcolor={COLORS.white}
        brcolor={"transparent"}
        width="30%"
        className="center-btn"
        brradius="24px"
        type="large"
        onClick={handleSave}
      >
        <LittleSubHeadline>Зберегти зміни</LittleSubHeadline>
      </Button>
    </AppLayout>
  );
}
